import { render, staticRenderFns } from "./M2hSeries.vue?vue&type=template&id=213260db&scoped=true&"
import script from "./M2hSeries.vue?vue&type=script&lang=js&"
export * from "./M2hSeries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213260db",
  null
  
)

export default component.exports